(function () {
  if (window.__atcFeedbackInit) return;
  window.__atcFeedbackInit = true;

  var ADD_RE = /\/cart\/add(\.js)?(\?|$|#)/i;
  var SUCCESS_DURATION_MS = 1500;
  var PENDING_TIMEOUT_MS = 8000;
  // FIFO queue of in-flight submissions, keyed to the exact form that
  // triggered them — NOT a single "last clicked anywhere" slot. A single
  // slot let an unrelated /cart/add success (e.g. from the size-picker
  // sheet, which isn't a form submit) steal the highlight and flash a
  // stale, unrelated card's button.
  var pending = [];

  function showSuccess(btn) {
    if (!btn) return;
    btn.classList.add('is-added-to-cart');
    setTimeout(function () {
      btn.classList.remove('is-added-to-cart');
    }, SUCCESS_DURATION_MS);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var btn = form.querySelector('.m-add-to-cart');
    if (btn) pending.push({ btn: btn, at: Date.now() });
  }, true);

  function maybeShowSuccess() {
    var now = Date.now();
    while (pending.length && now - pending[0].at > PENDING_TIMEOUT_MS) {
      pending.shift();
    }
    var entry = pending.shift();
    if (entry) showSuccess(entry.btn);
  }

  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function () {
      var args = arguments;
      var url = '';
      try {
        var first = args[0];
        url = typeof first === 'string' ? first : (first && first.url) || '';
      } catch (_) {}
      var promise = origFetch.apply(this, args);
      if (url && ADD_RE.test(url)) {
        promise.then(function (res) {
          if (res && res.ok) maybeShowSuccess();
        }, function () {});
      }
      return promise;
    };
  }

  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__atcUrl = url;
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var url = this.__atcUrl;
    if (url && ADD_RE.test(url)) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) {
          maybeShowSuccess();
        }
      });
    }
    return origSend.apply(this, arguments);
  };
})();
